import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function GarageDoorSpringRepair() {
  return <ServiceDetail serviceKey="springs" />;
}